import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * A new page opens at its top. The router keeps the window's scroll position across
 * navigations, so a page reached from the foot of a long list opened at its foot — the worker
 * profile showed Sign Out first and had to be scrolled up. A hash is left alone: that is a
 * request for a place on the page, and the page scrolls itself there.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
